import React                        from 'react'
import PropTypes                    from 'prop-types'
import styled                       from 'styled-components'
import { app }                      from '../../services/firebase'
import { withStyles }   from '@material-ui/core/styles'
import { 
  LinearProgress,
  Typography, 
  Button,
  Box
} from '@material-ui/core'

const UPLOADING = 1,
      SUCCESS   = 2,
      ERROR     = 3,
      INITIATED = 0

const upRef = app.storage().ref().child('/uploads')

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
`
const FilesDisplay = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
`
const FileRow = styled.div`
  width: 100%;
`

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    background: '#c358d4',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 12,
    width: '200px',
    textAlign: 'center',
    '&:hover': {
      background: '#942ba5'
    }
  },
  input: {
    display: 'none'
  }
})

function extensionSpliter (filename) {
  return filename.split(/\.(?!.*\..*)/)
}

function LinearProgressWithLabel (props) {
  return (
    <Box display='felx' alignItems='center'>
      <Box width='100%' mr={1}>
        <LinearProgress variant='determinate' {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant='body2' color='white'>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

class MultiFileUpload extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.handleFiles = this.handleFiles.bind(this)
    this.setUploadsFromFiles = this.setUploadsFromFiles.bind(this)
  }

  setUploadsFromFiles (files, cb) {
    const toUpload = {...this.state}
    for (let file of files) {
      let key = file.name
      for (let n = 1; this.state.hasOwnProperty(key); n++)
        key = file.name+' ('+n+')';

      const up = {
        file,
        name: file.name,
        ref: null,
        task: null, 
        progress: null,
        url: null,
        status: INITIATED
      }
      toUpload[key] = up
    }
    this.setState(Object.assign({}, toUpload), cb)
  }

  handleFiles (e) {
    this.setUploadsFromFiles(e.target.files, () => {
      this.props.onUploading() // let parent know an uploading is ocurring
      upRef.listAll().then(res => { // check if file name already exists
        const toUpload = {...this.state}
        for (let file in toUpload) {
          const u = toUpload[file]
          if (u.status === INITIATED) {
            let n = 1
            const [fileName, fileExt] = extensionSpliter(u.file.name)
            const existingNames = res.items.map(i => i.name)
            while (existingNames.includes(u.name)) { // if it does, change it until it doesn't
              u.name = fileName+'-'+n+'.'+fileExt
              n++
            }
            u.ref = upRef.child(u.name)
            u.task = u.ref.put(u.file)
            u.status = UPLOADING
            this.setState(
              {...this.state, ...toUpload},
              () => {
              u.task.on('state_changed',
                snapshot => {
                  const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                  u.progress = progress
                  const updateObj = {}
                  updateObj[file] = u
                  this.setState({...this.state, ...updateObj})
                },
                e => {
                  console.error(e)
                  const updateObj = {}
                  u.status = ERROR
                  updateObj[file] = u
                  this.setState({...this.state, ...updateObj}, () => {
                    for (let file in this.state) {
                      if (this.state[file].status === UPLOADING || this.state[file].status === INITIATED) {
                        return
                      }
                    }
                    const returnData = []
                    for (let file in this.state) {
                      returnData.push({
                        url: this.state[file].url,
                        name: this.state[file].file.name,
                      })
                    }
                    this.props.onAllFinished(returnData.filter(u => !!u.url))
                  })
                },
                () => {
                  u.ref.getDownloadURL()
                  .then(url => {
                    u.url = url
                    u.status = SUCCESS
                  })
                  .catch(e => u.status = ERROR)
                  .finally(() => {
                    const updateObj = {}
                    u.status = SUCCESS
                    updateObj[file] = u
                    this.setState({...this.state, ...updateObj}, () => {
                      for (let file in this.state) {
                        if (this.state[file].status === UPLOADING || this.state[file].status === INITIATED) {
                          return
                        }
                      }
                      const returnData = []
                      for (let file in this.state) {
                        returnData.push({
                          url: this.state[file].url,
                          name: this.state[file].file.name,
                        })
                      }
                      this.props.onAllFinished(returnData.filter(u => !!u.url))
                    })
                  })
                }
              )
            })
          }
        }
      })
    })
  }

  render () {
    const fileBars = []
    for (let file in this.state) {
      const u = this.state[file]
      switch (u.status) {
        case UPLOADING: fileBars.push(
            <FileRow key={u.name}>
              {u.file.name}
              <LinearProgressWithLabel value={u.progress} />
            </FileRow>
          )
          break
        case INITIATED: fileBars.push(
            <FileRow key={u.name}>
              {u.file.name}
              <LinearProgress variant='indeterminate' value={0} />
              <Typography variant='caption' size={12}>
                Iniciando envio...
              </Typography> 
            </FileRow>
          )
          break
        case SUCCESS: fileBars.push(
            <FileRow key={u.name}>
              {u.file.name}
    
              <LinearProgress variant='determinate' value={100} />
              <Typography variant='caption' size={12}>
                Finalizado
              </Typography> 
            </FileRow>
          )
          break
        case ERROR: fileBars.push(
            <FileRow key={u.name}>
              {u.file.name}
    
              <LinearProgress variant='determinate' value={0} />
              <Typography variant='caption' size={12}>
                Erro ao enviar aquivo
              </Typography> 
            </FileRow>
          )
          break
        default:
          break
      }
    }

    return <Container>
      <label htmlFor='files-input'>
        <Button variant='contained' component='span' className={this.props.classes.button}>Adcionar arquivos</Button>
      </label>
      <input 
        id='files-input'
        type='file' multiple
        className={this.props.classes.input}
        onChange={this.handleFiles} 
      />
      <Box>
        <FilesDisplay>
          { fileBars }
        </FilesDisplay>
      </Box>
    </Container>
  }
}

MultiFileUpload.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MultiFileUpload)